import React from 'react';
import { Phone, MessageCircle, Mail, MapPin, ArrowUpRight } from 'lucide-react';

export default function Contact() {
  return (
    <section id="contact" className="relative py-24 md:py-36 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-px bg-[#e4cfaf]" />
          <span className="uppercase text-[11px] tracking-[0.28em] text-[#e4cfaf]/90">Let&#39;s talk</span>
        </div>
        <h2 className="serif text-white text-4xl md:text-6xl lg:text-7xl leading-[1.02] max-w-4xl">
          Let&#39;s make your property <span className="italic-serif">stress-free.</span>
        </h2>
        <p className="mt-8 text-white/65 text-lg md:text-xl leading-relaxed max-w-2xl">
          Join landlords across Kent, West, South East and East London enjoying guaranteed rent and complete peace of mind. We reply within 24 hours.
        </p>

        <div className="mt-10 flex flex-wrap gap-4">
          <a
            href="tel:+447538449912"
            className="btn-primary px-6 py-4 rounded-full inline-flex items-center gap-2 text-sm md:text-base"
          >
            <Phone className="w-4 h-4" /> Book a Call Today <ArrowUpRight className="w-4 h-4" />
          </a>
          <a
            href="https://wa.me/447538449912?text=Hi%2C%20I%27m%20interested%20in%20your%20HMO%20rent%20to%20rent%20service."
            target="_blank"
            rel="noreferrer"
            className="btn-outline px-6 py-4 rounded-full inline-flex items-center gap-2 text-sm md:text-base"
          >
            <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
          </a>
        </div>

        <div className="mt-20 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          <div className="bg-[#0f0f10] p-8 md:p-10">
            <div className="flex items-center gap-3 text-[#e4cfaf] mb-4">
              <Phone className="w-4 h-4" />
              <span className="uppercase text-[10px] tracking-[0.28em]">Call us</span>
            </div>
            <div className="serif text-white text-xl md:text-2xl">+44 7538 449912</div>
          </div>
          <div className="bg-[#0f0f10] p-8 md:p-10">
            <div className="flex items-center gap-3 text-[#e4cfaf] mb-4">
              <Mail className="w-4 h-4" />
              <span className="uppercase text-[10px] tracking-[0.28em]">Email</span>
            </div>
            <div className="serif text-white text-base md:text-lg break-all">gurpreet@msrresidentialgroup.uk</div>
          </div>
          <div className="bg-[#0f0f10] p-8 md:p-10">
            <div className="flex items-center gap-3 text-[#e4cfaf] mb-4">
              <MapPin className="w-4 h-4" />
              <span className="uppercase text-[10px] tracking-[0.28em]">Coverage</span>
            </div>
            <div className="serif text-white text-lg md:text-xl leading-tight">Kent, West, South East &amp; East London</div>
          </div>
        </div>
      </div>
    </section>
  );
}
